import React, { useEffect } from "react";
// import india from "../flags/in.png";
// import austria from "../flags/at.png";
import codes from "./country_codes";
// import belgium from "../flags/be.png";
// import nl from "../flags/nl.png";
// import hu from "../flags/hu.png";
// import at from "../flags/at.png";
// import my from "../flags/my.png";
// import jp from "../flags/jp.png";
// import kr from "../flags/kr.png";
// import pt from "../flags/pt.png";
// import ie from "../flags/ie.png";
// import ax from "../flags/ax.png";
// import mv from "../flags/mv.png";
// import au from "../flags/au.png";
// import bh from "../flags/bh.png";
// import br from "../flags/br.png";
// import ca from "../flags/ca.png";
// import cz from "../flags/cz.png";
// import dk from "../flags/dk.png";
// import isreal from "../flags/il.png";
const allowedCountry = [
  "+91",
  "+61",
  "+43",
  "+973",
  "+32",
  "+55",
  "+1",
  "+420",
  "+45",
  "+20",
  "+358",
  "+33",
  "+49",
  "+30",
  "+852",
  "+36",
  "+62",
  "+354",
  "+972",
  "+39",
  "+81",
  "+965",
  "+372",
  "+60",
  "+960",
  "+230",
  "+52",
  "+31",
  "+64",
  "+47",
  "+968",
  "+63",
  "+48",
  "+351",
  "+974",
  "+7",
  "+966",
  "+65",
  "+82",
  "+27",
  "+34",
  "+46",
  "+268",
  "+66",
  "+90",
  "+971",
  "+44",
  "+1",
  "+84",
];
const allowedCode = [
  "IN",
  "US",
  "GB",
  "AU",
  "GR",
  "NL",
  "BE",
  "HU",
  "AT",
  "MY",
  "JP",
  "KR",
  "PT",
  "IE",
  "AX",
  "MV",
  "IL",
  "SG",
  "TW",
  "ES",
];

const test = () => {
  return allowedCode.map((code) => {
    let result = codes.find((data) => data.code === code);
    if (result) {
      return (
        <option defaultValue value={result.dial_code}>
          <img
            alt=""
            height={12}
            width={17}
            src={`./flag/${result.code}.png`}
          />
          &emsp;{result.dial_code} {}
        </option>
      );
    } else {
      return <></>;
    }
  });
};
export const countryCodeWithoutFlag = () => {
  return allowedCode.map((code) => {
    let result = codes.find((data) => data.code === code);
    if (result) {
      return (
        <option defaultValue value={result.dial_code}>
          {result.dial_code} {}
        </option>
      );
    } else {
      return <></>;
    }
  });
};

export const countryCodeOptions = () => {
  // let finalCountryList = [];

  // allowedCountry.map((country) => {
  //   finalCountryList.push(
  //     codes.find((country) => country.dial_code === country)
  //   );
  //   return 0;
  // });

  return (
    <>{test()}</>
    // <>
    //   <option defaultValue value="+91">
    //     <img alt="india" height={12} width={17} src={india} />
    //     &emsp;+91 {}
    //   </option>
    //   <option value="+61">
    //     {" "}
    //     <img alt="" height={12} width={17} src={au} />
    //     &emsp;+61
    //   </option>
    //   <option value="+43">
    //     {" "}
    //     <img alt="" height={12} width={17} src={at} />
    //     &emsp;+43
    //   </option>
    //   <option value="+973">
    //     {" "}
    //     <img alt="" height={12} width={17} src={bh} />
    //     &emsp;+973
    //   </option>
    //   <option value="+32">
    //     {" "}
    //     <img alt="" height={12} width={17} src={belgium} />
    //     &emsp;+32{" "}
    //   </option>
    //   <option value="+55">
    //     {" "}
    //     <img alt="" height={12} width={17} src={br} />
    //     &emsp;+55{" "}
    //   </option>
    //   <option value="+1">
    //     {" "}
    //     <img alt="" height={12} width={17} src={ca} />
    //     &emsp;+1{" "}
    //   </option>
    //   <option value="+420">
    //     <img alt="" height={12} width={17} src={cz} />
    //     &emsp;+420
    //   </option>
    //   <option value="+45">
    //     <img alt="" height={12} width={17} src={dk} />
    //     &emsp;+45
    //   </option>
    //   <option value="+30">
    //     <img alt="" height={12} width={17} src={austria} />
    //     &emsp;+30
    //   </option>
    //   <option value="+31">
    //     <img alt="" height={12} width={17} src={belgium} />
    //     &emsp;+31
    //   </option>

    //   <option value="+36">
    //     {" "}
    //     <img alt="" height={12} width={17} src={hu} />
    //     &emsp;+36
    //   </option>

    //   <option value="+60">
    //     {" "}
    //     <img alt="" height={12} width={17} src={my} />
    //     &emsp;+60
    //   </option>
    //   <option value="+81">
    //     {" "}
    //     <img alt="" height={12} width={17} src={jp} />
    //     &emsp;+81
    //   </option>
    //   <option value="+82">
    //     {" "}
    //     <img alt="" height={12} width={17} src={kr} />
    //     &emsp;+82
    //   </option>
    //   <option value="+351">
    //     {" "}
    //     <img alt="" height={12} width={17} src={pt} />
    //     &emsp;+351
    //   </option>
    //   <option value="+353">
    //     {" "}
    //     <img alt="" height={12} width={17} src={ie} />
    //     &emsp;+353
    //   </option>
    //   <option value="+358">
    //     {" "}
    //     <img alt="" height={12} width={17} src={ax} />
    //     &emsp;+358
    //   </option>
    //   <option value="+960">
    //     {" "}
    //     <img alt="" height={12} width={17} src={mv} />
    //     &emsp;+960
    //   </option>
    //   <option value="+972">
    //     {" "}
    //     <img alt="" height={12} width={17} src={isreal} />
    //     &emsp;+972
    //   </option>
    // </>
  );
};
